export default () => [
  {
    dataField: "type",
    text: "Type",
  },
  {
    dataField: "subtype",
    text: "Subtype",
  },
  {
    dataField: "launch",
    text: "Launch",
  },
  {
    dataField: "created_dt",
    text: "Last_Launch_Date",
  },
  {
    dataField: "proc_status",
    text: "Current Status",
  },
];
